const OVERLAY_ID = 'search-loading';

function getLabel() {
  return window.globalInfo?.searchLoadingLabel || 'Loading…';
}

function ensureOverlay() {
  let overlay = document.getElementById(OVERLAY_ID);

  if (overlay) {
    return overlay;
  }

  overlay = document.createElement('div');
  overlay.id = OVERLAY_ID;
  overlay.className = 'search-loading';
  overlay.hidden = true;
  overlay.setAttribute('role', 'status');
  overlay.setAttribute('aria-live', 'polite');
  overlay.setAttribute('aria-busy', 'false');
  overlay.innerHTML = `
    <div class="search-loading__panel">
      <div class="search-loading__spinner" aria-hidden="true"></div>
      <p class="search-loading__label">${getLabel()}</p>
    </div>
  `;
  document.body.appendChild(overlay);

  return overlay;
}

export function showSearchLoading(label) {
  const overlay = ensureOverlay();
  const labelEl = overlay.querySelector('.search-loading__label');

  if (labelEl) {
    labelEl.textContent = label || getLabel();
  }

  overlay.hidden = false;
  overlay.setAttribute('aria-busy', 'true');
  document.documentElement.classList.add('is-search-loading');
}

export function hideSearchLoading() {
  const overlay = document.getElementById(OVERLAY_ID);

  if (!overlay) {
    return;
  }

  overlay.hidden = true;
  overlay.setAttribute('aria-busy', 'false');
  document.documentElement.classList.remove('is-search-loading');
}

function formHasQuery(form) {
  const input = form.querySelector('[name="q"]');
  return Boolean(input && input.value.trim());
}

export function initSearchLoading() {
  ensureOverlay();

  document.addEventListener('submit', (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement) || !form.classList.contains('js-search-form')) {
      return;
    }

    if (!formHasQuery(form)) {
      return;
    }

    showSearchLoading();
  });

  const sortSelect = document.getElementById('js-search-sort');
  const searchForm = document.getElementById('search-form');

  if (sortSelect && searchForm) {
    sortSelect.addEventListener('change', () => {
      showSearchLoading();
      searchForm.submit();
    });
  }

  if (searchForm) {
    document.querySelectorAll('.pagination a').forEach((link) => {
      link.addEventListener('click', () => {
        showSearchLoading();
      });
    });
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      hideSearchLoading();
    }
  });
}
